import groq from 'groq'

import { callToAction } from './callToAction.js'

export function footer() {
	return groq`
 *[_type == 'sharedContent'][0] {
   ...footer {
     title,
     description,
     ctaTitle,
     cta {${callToAction()}}
   }
  }
`
}
